import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { HomeSlider } from "./home-slider.model";
import { Slide } from "./slide.model";
import { SlideAction } from "./slide-action.model";

@Injectable()
export class HomeSliderFormService {
  constructor(private fb: FormBuilder) {}

  getForm(homeSlider: HomeSlider = new HomeSlider()): FormGroup {
    return this.fb.group({
      _id: [homeSlider._id],
      active: [homeSlider.active],
      slides: this.fb.array(
        homeSlider.slides.map(item => this.getSlideForm(item))
      )
    });
  }

  getSlideForm(slide: Slide = new Slide()): FormGroup {
    return this.fb.group({
      _id: [slide._id],
      title: [slide.title],
      subtitle: [slide.subtitle],
      content: [slide.content],
      contentPosition: [slide.contentPosition],
      textColor: [slide.textColor],
      textBackground: [slide.textBackground],
      backgroundImage: [slide.backgroundImage],
      backgroundVideo: [slide.backgroundVideo],
      image: [slide.image],
      imageMobile: [slide.imageMobile],
      backgroundHorizontalPosition: [slide.backgroundHorizontalPosition],
      completedLocales: [slide.completedLocales],
      backgroundVerticalPosition: [slide.backgroundVerticalPosition],
      position: [slide.position],
      active: [slide.active],
      actions: this.fb.array(
        slide.actions.map(item => this.getSlideActionForm(item))
      )
    });
  }

  getSlideActionForm(action: SlideAction = new SlideAction()): FormGroup {
    return this.fb.group({
      _id: [action._id],
      label: [action.label],
      action: [action.action],
      position: [action.position]
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/home-slider-form.service.ts